//import * as $ from 'jquery';
export const wooCartRefresh = () => {
    fetch('/wp-admin/admin-ajax.php?action=get_cart_count', {
        method: 'GET',
        credentials: 'same-origin'
    })
        .then(r => r.json())
        .then(res => {
            if (!res.success) return;

            const el = document.querySelector('.cart-count');
            if (el) el.textContent = res.data.count;
        });
}